/* eslint-disable no-unused-vars */
export enum MessageLevel {
  Warn = 'Warn',
  Error = 'Error',
  Info = 'Info',
  Success = 'Success'
}

export interface DownloadCSVData { data: any[], download: boolean; }